import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Apikey } from '../../../../model/api-key.model';
import { IpAdressService } from '../../api-key/ip-adress.service';
import { ApiKeyService } from '../../api-key/api-key.service';
import { CUserApiKeyService } from '../../../../services/ServiceEntity/c-user-api-key.service';
import { BaseService } from '../../base/base.service';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../shared/services/form.service';
import { TCModalService } from '../../../../ui/services/modal/modal.service';
import { CountryService } from '../../countries/countries.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { takeUntil } from 'rxjs/operators';
import { IIpAdressDTO, IpAdressDTO } from '../../../../model/ipAdress.model';
import { TIME_MIN_X1_REQUEST, TIME_MIN_X2_REQUEST } from '../../../../shared/constant/request.contant';

/**
 * Permet de gérer l'ajout des api key.
 */
@Component({
  selector: 'app-ip-adress-update',
  templateUrl: './ip-adress-update.component.html',
  animations: [fadeIn]
})
export class IpAdressUpdateComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;

  theDialogRef: MatDialogRef<IpAdressUpdateComponent>;
  private subs$ = new Subject<void>();

  editForm: UntypedFormGroup;
  idAccount: number;

  apiKey: Apikey;
  ipAdress: IIpAdressDTO;

  constructor(
    private ipAdressService: IpAdressService,
    private apiKeyService: ApiKeyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private domainService: CUserApiKeyService,
    public baseService: BaseService,
    private accountService: AccountService,
    private formService: FormService,
    private dialogRef: MatDialogRef<IpAdressUpdateComponent>,
    private fb: UntypedFormBuilder,
    private modal: TCModalService,
    private countryService: CountryService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct ip adress liste');
    this.theDialogRef = this.dialogRef;
    console.log('## idAccount: ', this.data.idAccount);
    this.idAccount = this.data.idAccount;
    this.ipAdress = this.data.ipAdress;
    this.initForm(fb);
  }

  ngOnInit(): void {
    console.log('## init ip adress liste');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {
        try {
          const ip = this.ipAdress;
          this.editForm.patchValue({
            ['id']: ip.id,
            ['label']: ip.label,
            ['description']: ip.description,
            ['apiKeyId']: ip.apiKeyId
          })
        }catch (e) {
          console.log('## error get ip adress selected: ' + e.message);
        }
      });
    super.setLoaded();
  }

  ngOnDestroy() {
    console.log('## destroy ip adress liste');
    this.formService.free(this.subs$);
  }

  initForm(fb: UntypedFormBuilder) {
    if (fb) {
      this.editForm = fb.group({
        ['id']: [],
        ['label']: [null, [Validators.required]],
        ['description']: [],
        ['apiKeyId']: []
      })
    }
  }

  private createFromForm(): IIpAdressDTO {
    return {
      ...new IpAdressDTO(),
      id: this.editForm.get('id').value,
      label: this.editForm.get('label').value,
      description: this.editForm.get('description').value,
      apiKeyId: this.editForm.get('apiKeyId').value
    };
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    console.log('## updating ip adress');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const c = this.createFromForm();
    this.ipAdressService.updateOne(c)
      .subscribe(res => {
        console.log('## success liste one ip adress');
        this.successSave = true;
        setTimeout(() => {
          this.ipAdressService.eventEmitter.emit('list');
        }, TIME_MIN_X1_REQUEST);
        setTimeout(() => {
          this.isSaving = false;
          this.close();
        }, TIME_MIN_X2_REQUEST);
      }, err => {
        console.log('## error liste one ip adress: ', err);
        this.responseFromServer();
        this.serverHasError = true;
        this.successSave = false;
        this.isSaving = false;
      });

  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300);
  }

}